import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StudenttestingdownloadService {

  private dataSource = new BehaviorSubject<any>(null);
  currentData = this.dataSource.asObservable();
  constructor() { }

  updateData(data: any) {
    this.dataSource.next(data);
  }
}
